import { apiSlice } from "@/redux/rtk/features/apiSlice/apiSlice";

export const userColumnSettingsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUserColumnSettings: builder.query({
      query: (tableKey) => ({
        url: `user-column-settings/${tableKey}`,
      }),
      providesTags: (result, error, tableKey) => [{ type: "UserColumnSettings", id: tableKey }],
    }),

    saveUserColumnSettings: builder.mutation({
      query: (values) => ({
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `user-column-settings`,
        body: values,
      }),
      invalidatesTags: (result, error, { tableKey }) => [{ type: "UserColumnSettings", id: tableKey }],
    }),

    resetUserColumnSettings: builder.mutation({
      query: (tableKey) => ({
        url: `user-column-settings/${tableKey}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, tableKey) => [{ type: "UserColumnSettings", id: tableKey }],
    }),
  }),
});

export const {
  useGetUserColumnSettingsQuery,
  useSaveUserColumnSettingsMutation,
  useResetUserColumnSettingsMutation,
} = userColumnSettingsApi;
